const doc = [({"en":({"js":({"notifications":({"types":({"team_application_declined":({"your_application_to_team_was_declined":"Your application to %{team_name} was declined."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;